import { smoothScrollTo } from '../../Utilities/SmoothScroll';

const priceBtn: HTMLElement | null = document.querySelector('.PriceCompareBtn');

const stickyButtonPriceCompareHandler = (target: HTMLElement) => (event: Event) => {
    event.preventDefault();
    const distance: number = target.getBoundingClientRect().top + window.scrollY;
    smoothScrollTo(distance);
};

export const toggleStickyPriceCompareButton = (entry: IntersectionObserverEntry, options?: any) => {
    if (priceBtn === null) {
        return;
    }

    let shouldShow = true;

    // If on mobile device, account for when virtual keyboard is shown
    if (window.screen.availWidth < 768) {
        // Remove display none and add visibility: none so we can get the button BoundingClientRect on the viewport
        priceBtn.classList.add('invisible');
        priceBtn.classList.remove('xs:hidden');
        shouldShow = priceBtn.getBoundingClientRect().bottom > (window.screen.availHeight / 2);
        
        // reset visibility
        priceBtn.classList.remove('invisible');
    }

    if (shouldShow === false) {
        priceBtn.classList.add('xs:hidden');
        return;
    }

    // Use entry.intersectionRatio if need more precise when hiding/showing the button
    entry.intersectionRatio > 0.5 ? priceBtn.classList.add('xs:hidden') : priceBtn.classList.remove('xs:hidden');

};

export const StickyButtonPriceCompareClient = (target: HTMLElement): void => {
    const btn: HTMLElement | null = document.querySelector('.PriceCompareBtn button');

    if (btn !== null) {
        btn.addEventListener('click', stickyButtonPriceCompareHandler(target));
        btn.addEventListener('touchend', stickyButtonPriceCompareHandler(target));
    }
};
